"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Nursing.module.css"));
function Header(props) {
    var children = props.children, classNames = props.classNames;
    return (React.createElement("div", { className: styles.headerWrapRefund + " " + (classNames || "") },
        React.createElement("img", { className: styles.headerLogoImg, src: "/img/logo-intel.png", alt: "" }),
        React.createElement("div", { className: styles.headerTitleWrap }, children)));
}
exports.Header = Header;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvaW50ZWxsaXRlYy9FbnJvbGxtZW50QWdyZWVtZW50L051cnNpbmcvSGVhZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSwyQ0FBOEI7QUFDOUIsMkRBQThDO0FBRTlDLFNBQWdCLE1BQU0sQ0FBQyxLQUFLO0lBQ2pCLElBQUEseUJBQVEsRUFBRSw2QkFBVSxDQUFTO0lBRXBDLE9BQU8sQ0FDSCw2QkFBSyxTQUFTLEVBQUssTUFBTSxDQUFDLGdCQUFnQixVQUFJLFVBQVUsSUFBSSxFQUFFLENBQUU7UUFDNUQsNkJBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxhQUFhLEVBQUUsR0FBRyxFQUFDLHFCQUFxQixFQUFDLEdBQUcsRUFBQyxFQUFFLEdBQUc7UUFDekUsNkJBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxlQUFlLElBQUcsUUFBUSxDQUFPLENBQ3RELENBQ1QsQ0FBQTtBQUNMLENBQUM7QUFURCx3QkFTQyJ9